import { SKUDTO } from './SKUDTO'
import { VoucherSKUValueDTO } from './VoucherSKUValueDTO'

export class VoucherDTO {
    constructor(
        public id: string,
        public displayName: string,
        public description: string | null,
        public imageId: string | null,
        public policy: string | null,
        public expiryMonths: number | null,
        public expiryDate: string | null,
        public postalDeliveryFee: number | null,
        public skus: SKUDTO[],
        public skuValues: VoucherSKUValueDTO[] = [],
        public dateCreated: string,
        public dateUpdated: string
    ) { }
}
